import TopUpStatusMessage from './TopUpStatusMessage';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import { useQuery } from '@tanstack/react-query';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { FormattedMessage } from 'react-intl';
import messages from './TopUpStatusMessages.messages';

export const NotYetTopUpEligible = ({ accountId }: { accountId: string }) => {
    const stateKey = useStateKey();

    const {
        data: accountsResponse,
        isLoading,
        isError
    } = useQuery(getAccountsQueryConfig(stateKey));

    if (isLoading || isError) return null;

    const account = accountsResponse.data!.accounts.find(
        (account) => account.account_id === accountId
    )!;
    const amountToRepayBeforeTopUp =
        account.topup_eligibility!.amount_to_repay_before_topup;

    return (
        <TopUpStatusMessage
            heading={
                <>
                    <FormattedMessage
                        {...messages.notYetTopupEligilbeAlertText}
                        values={{
                            amount: (
                                <FormattedCurrency
                                    value={amountToRepayBeforeTopUp}
                                />
                            )
                        }}
                    />
                </>
            }
            description={
                <FormattedMessage
                    {...messages.notYetTopupEligilbeAlertDescription}
                />
            }
            ctaText={<FormattedMessage {...messages.notTopupEligilbeCTAText} />}
        />
    );
};
